import { TemplateHistoryApiResultObject } from "./TemplateHistoryApiResult";
import { CustomerNameId, 
         ItemNameNumber, 
         PromotionNameId, 
         ProductLineCategoryNameNumber, 
         ProductLineNameNumber } from "./TemplateMetadataModels";

export type PromotionEntryTemplateHistoryApiResultObject = 
    TemplateHistoryApiResultObject & 
    PromotionEntryTemplateHistoryMetadata;

export type PromotionEntryTemplateHistoryMetadata = {
    Customers: CustomerNameId[] | null,
    Items: ItemNameNumber[] | null,
    Promotions: PromotionNameId[] | null,
    ProductLines: ProductLineNameNumber[] | null,
    ProductLineCategories: ProductLineCategoryNameNumber[] | null
}

export const PromotionEntryTemplateHeaderRows_AoA = [
    [
        "NEW/EXISTING",
        "PROMOTION ID",
        "PROMOTION DESC",
        "PROMOTION TYPE",
        "PROMOTION CATEGORY",
        "EXCEPTION TYPE",

        "CUSTOMER ID",
        "CUSTOMER NAME",

        "COUNTRY CODE",
        "SEGMENT",
        "CHANNEL",
        "TIER",
        "BUYING GROUP",
        "CORPORATE AFFILIATION",
        "PRICE ZONE",
        "FREIGHT ZONE",

        "PRODUCT LINE",
        "PRODUCT CATEGORY",

        "ITEM NUMBER",
        "MANUFACTURERS NUMBER",
        "GTIN",
        "ALLOW MULTIPLE",

        "EMPLOYEE RESPONSIBLE PRICING",
        "JOB TYPE",
        "SUPPLIER FLAG",

        "PROMOTION AMOUNT",
        "UOM",
        "WEIGHT TYPE",
        "PROMOTION PERCENT",

        "MINIMUM VALUE",
        "MINIMUM CODE",

        "MAXIMUM VALUE",
        "MAXIMUM CODE",

        "BEGIN ORDER DATE",
        "END ORDER DATE",
        "BEGIN DELIVERY DATE",
        "END DELIVERY DATE",

        "PROMOTION ADJUSTMENT",
        "CASE QUANTITY",
        "SERVICE LOCATION",
    ]
];
